export class Cart {
  items: any[];
  totalQty: number;
  totalPrice: number;
  onePayment: number;
  maxPayments: number;
  discountPrice?: number;
}



// WEBPACK FOOTER //
// ./src/app/_models/cart.ts